import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const CreateDiagnosticReportDocument = gql`
  mutation CreateDiagnosticReport(
    $effectiveDateTime: String!
    $subjectRef: String!
    $datasetId: String!
  ) {
    createDiagnosticReport(
      diagnosticReport: {
        resourceType: DiagnosticReport
        status: registered
        code: { coding: { system: "http://loinc.org", code: "81247-9" } }
        effectiveDateTime: $effectiveDateTime
        subject: { reference: $subjectRef }
        meta: {
          tag: [
            { code: $datasetId, system: "http://lifeomic.com/fhir/dataset" }
            {
              code: "LifeOmic Variant Selection"
              system: "http://lifeomic.com/fhir/source"
            }
          ]
        }
      }
    ) {
      __typename
      status
      code {
        coding {
          system
          code
        }
      }
      effectiveDateTime
      subject {
        reference
      }
      meta {
        tag {
          code
          system
        }
      }
      id
    }
  }
`;
export type CreateDiagnosticReportMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateDiagnosticReportMutationResponse,
    CreateDiagnosticReportMutationVariables
  >;

/**
 * __useCreateDiagnosticReportMutation__
 *
 * To run a mutation, you first call `useCreateDiagnosticReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiagnosticReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiagnosticReportMutation, { data, loading, error }] = useCreateDiagnosticReportMutation({
 *   variables: {
 *      effectiveDateTime: // value for 'effectiveDateTime'
 *      subjectRef: // value for 'subjectRef'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useCreateDiagnosticReportMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateDiagnosticReportMutationResponse,
    CreateDiagnosticReportMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateDiagnosticReportMutationResponse,
    CreateDiagnosticReportMutationVariables
  >(CreateDiagnosticReportDocument, baseOptions);
}
export type CreateDiagnosticReportMutationHookResult = ReturnType<
  typeof useCreateDiagnosticReportMutation
>;
export type CreateDiagnosticReportMutationResult =
  ApolloReactCommon.MutationResult<CreateDiagnosticReportMutationResponse>;
export type CreateDiagnosticReportMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateDiagnosticReportMutationResponse,
    CreateDiagnosticReportMutationVariables
  >;
export type CreateDiagnosticReportMutationVariables = Types.Exact<{
  effectiveDateTime: Types.Scalars['String'];
  subjectRef: Types.Scalars['String'];
  datasetId: Types.Scalars['String'];
}>;

export type CreateDiagnosticReportMutationResponse = {
  __typename: 'Mutation';
  createDiagnosticReport: {
    __typename: 'DiagnosticReport';
    status: Types.DiagnosticReportStatus;
    effectiveDateTime?: Types.Maybe<string>;
    id?: Types.Maybe<string>;
    code: {
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    };
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    meta?: Types.Maybe<{
      __typename: 'Meta';
      tag?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          code?: Types.Maybe<string>;
          system?: Types.Maybe<string>;
        }>
      >;
    }>;
  };
};
